module.exports = __webpack_public_path__ + "img/icons-fill-jobs.470e543a.svg";